"use client"
import React, { useState } from 'react'
import AwardCard from './AwardCard'
import useFetch from '@/app/useFetch'
import Pegination from './Pegination'
import Loader from './Loader';

const FormerChiefs = () => {
 
  const [currentPage, setCurrentPage] = useState(1)
  const [limit, setLimit] = useState(12)
  const { data: list, totalPages, loading, error } = useFetch(
    "/website/vigilance-former-chiefs",
    {
      page: currentPage, limit: limit,
    },

    [currentPage, limit]
  );
  const handlePageChange = (pageNumber) => {
    if (pageNumber > 0 && pageNumber <= totalPages) {
      setCurrentPage(pageNumber)

      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
  if (loading) {
    return <Loader n={24} f={0.3} />
  }

  if (error) {
    return <section className='mt-40'>Error loading data: {error.message || 'An unexpected error occurred'}</section>
  }


  return (
    <section className="mt-40">
      <div className='row row-cols-lg-4 row-cols-md-3 row-cols-sm-2 row-cols-1 gy-4'>
        {list?.map((item, index) => (
          <>
            <AwardCard name={item.name} designation={item.designation} img={item.photo} detail={item.description} key={index} date={item.description} />
          </>
        ))}
      </div>
      {totalPages > 1 && (
        <Pegination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={handlePageChange}
        />
      )}
    </section>
  )
}

export default FormerChiefs
